import { resolveDeployPrefix } from './initialization/deployPrefixResolver.js';
import { monitorLoadingError } from './initialization/obsoleteApi.js';
import { b2bLanguageCodes } from './i18n.js';
import { fetchStaticPageOrTopic } from './apis/api-static-pages-and-topics.js';
import { stpShortTitles$ } from './stores/store-main.js';
const deployPrefix = resolveDeployPrefix();
const langPart = `:lang(${b2bLanguageCodes.join('|')})`;
export const routes = [
    {
        path: `${deployPrefix}/${langPart}`,
        action: async () => {
            const { PageB2bHome } = await monitorLoadingError(import('./pages/page-b2b-home.js'));
            const page = new PageB2bHome();
            return page;
        },
    },
    {
        path: `${deployPrefix}/${langPart}/:key(.+)`,
        action: async (context) => {
            const lang = context.params['lang'];
            const key = context.params['key'];
            try {
                const spt = await fetchStaticPageOrTopic(key, lang, true);
                stpShortTitles$.next(spt.titleShort);
                const { PageStaticOrTopic } = await monitorLoadingError(import('./pages/page-static-or-topic.js'));
                const sptElement = new PageStaticOrTopic();
                sptElement.spt = spt;
                switch (spt.kind) {
                    case 'static_page': {
                        sptElement.selectedTab = 0;
                        break;
                    }
                }
                return sptElement;
            }
            catch {
                const { PageNotFound } = await monitorLoadingError(import('./pages/page-not-found.js'));
                return new PageNotFound();
            }
        },
    },
    {
        path: `${deployPrefix}/(.*)`,
        action: async () => {
            throw new Error('page not found');
        },
    },
];
//# sourceMappingURL=b2b-router.js.map